
export enum enumHotCardReason {
  'New Card' = 1,
  'Stolen Card',
  'Lost Card',
  'Broken Card',
  'Risk Tolerance Limit Exceeded',
  'Invalid Data'
}

export namespace enumHotCardReason {
  export function values() {
    return Object.keys(enumHotCardReason).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
